import axios from "../axios/index.js";

const urlGetContactTypeList = "/api/contact/get-list";
const urlGetContactTypeDetail = "/api/contact/detail/";
const urlChangeRead = "/api/contact/change-read/";

export default {
    getList(params) {
        return axios.post(urlGetContactTypeList, params);
    },

    getDetail(id) {
        return axios.post(urlGetContactTypeDetail + id);
    },

    changeRead(params) {
        return axios.post(urlChangeRead + params.id, params);
    },
};
